import { action, Action } from 'easy-peasy';
import { isEqual } from 'lodash';
import { FontMaterialRaw } from '@meitu/xdesign-widgets';

export interface ITeamFontsModel {
    teamFonts: FontMaterialRaw[];
    setTeamFonts: Action<ITeamFontsModel, FontMaterialRaw[]>;
}
export const teamFontsModel: ITeamFontsModel = {
    teamFonts: [],
    setTeamFonts: action((state, payload) => {
        if (!isEqual(state.teamFonts, payload)) {
            state.teamFonts = payload;
        }
    }),
};
